import { useState, useCallback } from "react";
import DateTime from "../../../../external/luxon/src/datetime.js";
import "../../../../external/luxon/src/duration.js";
const useYearMonthSelector = (type, onChange) => {
  const [monthYearSelectorShown, showMonthYearSelector] = useState(!1), [currentSelectorType, setCurrentSelectorType] = useState("year"), close = () => showMonthYearSelector(!1), toggleShown = useCallback(
    () => showMonthYearSelector((prev) => !prev),
    []
  ), handleChange = useCallback(
    (date) => {
      currentSelectorType === "month" ? (showMonthYearSelector(!1), setCurrentSelectorType("year")) : setCurrentSelectorType("month");
      let newDate = date;
      type === "right" && (newDate = DateTime.fromISO(newDate).minus({ month: 1 }).toISODate()), onChange(newDate);
    },
    [currentSelectorType, onChange, type]
  ), toggleMonthYear = useCallback(
    (toggleType) => {
      toggleType && (toggleType === currentSelectorType || !monthYearSelectorShown) && showMonthYearSelector((prev) => !prev), setCurrentSelectorType(
        (d) => toggleType ?? (d === "year" ? "month" : "year")
      );
    },
    [currentSelectorType, monthYearSelectorShown]
  );
  return {
    shown: monthYearSelectorShown,
    type: currentSelectorType,
    handleChange,
    toggleShown,
    toggleMonthYear,
    close
  };
};
export {
  useYearMonthSelector
};
//# sourceMappingURL=useYearMonthSelector.js.map
